var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolarPanel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "yellow",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-solar-panel-icon lucide-solar-panel",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2h2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.28 14-4.56 8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m21 22-1.558-4H4.558"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10v2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.245 15.04A2 2 0 0 1 8 14h12a1 1 0 0 1 .864 1.505l-3.11 5.457A2 2 0 0 1 16 22H4a1 1 0 0 1-.863-1.506z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2a4 4 0 0 1-4 4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m8.66 7.66 1.41 1.41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarPanel);
export default __webpack_public_path__ + "static/media/solar-panel.f85caa3abfc93b752be14eee9423ab24.svg";
export { ForwardRef as ReactComponent };